<!-- アコーディオン -->
<template>
  <div class="crly-m-common-accordion">
    <div class="crly-m-common-accordion__head">
      <span>
        <slot name="label"></slot>
      </span>
      <span @click.stop="clickToggle" :class="{ open: isOpen }">
        <slot name="toggle"></slot>
      </span>
    </div>
    <div class="crly-m-common-accordion__contents" :style="{ height: height }">
      <div ref="contents">
        <slot name="contents"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CrlyMoleculesCommonAccordion",
  props: {
    /**
     * 表示エリアの高さ
     */
    contentsHeight: {
      type: Number,
      default: 0
    },
    /**
     * ジャンル検索表示用
     */
    genreHeight: {
      type: Number,
      default: 0
    },
    /**
     * 初期開閉状態
     */
    initStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      height: 0
    };
  },
  methods: {
    /**
     * トグルのクリックイベント
     */
    clickToggle() {
      this.$emit("clickToggle", !this.isOpen);
      this.isOpen = !this.isOpen;

      this.$nextTick(() => {
        this.setHeight();
      });
    },
    /**
     * 表示エリアに高さをセットする
     */
    setHeight() {
      if (this.isOpen) {
        if (this.contentsHeight) {
          // 高さが指定されている場合は、指定されている高さを使用する
          this.height = `${this.contentsHeight}px`;
        } else {
          this.height = `${this.calcHeight()}px`;
        }
      } else {
        this.height = 0;
      }
    },
    /**
     * 要素の高さを取得する
     */
    calcHeight() {
      const dom = this.$refs.contents;
      const rect = dom.getBoundingClientRect(); // 要素の座標と幅と高さを取得
      return rect.height;
    },
    /**
     * アコーディオンを強制的に閉じる
     */
    closeToggle() {
      this.isOpen = false;
      this.setHeight();
    }
  },
  watch: {
    contentsHeight: function (val) {
      this.setHeight(val);
    },
    genreHeight(val) {
      this.setHeight(val);
    }
  },
  mounted() {
    setTimeout(() => {
      // 100ミリ秒ほど待たないとアコーディオンの高さがうまく取得できない
      if (this.initStatus) {
        this.clickToggle();
      }
    }, 100);
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/accordion.scss";
</style>
